export type ListResponse<T> = {
  data: T[];
};

export type PaginatedListResponse<T> = {
  data: T[];
  meta: {
    total_count: number;
    page: number;
    page_size: number;
    total_pages: number;
  };
};

export type Response<T> = {
  data: T;
};

export type ApiResponse<T> = {
  data: T;
};

export type ApiClient = {
  baseUrl: string;
  getAuthToken?: () => Promise<string | null>;
  apiKey?: string;
  /**
   * The regions the app is currently looking at, or `undefined`/`null`/`[]`
   * for "all regions".
   *
   * Reading it is the client's job, not every call site's: `clientWithApiClient`
   * appends the selection to each GET it builds, so a list call written before
   * regions existed becomes region-scoped without being touched. Synchronous
   * on purpose — it reads app state the browser already holds, never the
   * network.
   */
  getRegionIds?: () => readonly string[] | null | undefined;
};

export class ApiError extends Error {
  status: number;
  data: Record<string, unknown>;

  constructor(status: number, message: string, data: Record<string, unknown>) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.data = data;
  }
}
